// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAnalyzeCustomMaps4_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6863 20.8162 11.6256 23.9982 14.8076 22.9375 21.8787 15.8664 19.7573 13.7451 12.6863 20.8162ZM20.4644 13.038 21.8787 11.6238 24 13.7451 22.5858 15.1593 20.4644 13.038ZM4.5 9C6.98528 9 9 6.98528 9 4.5 9 2.01472 6.98528 0 4.5 0 2.01472 0 0 2.01472 0 4.5 0 6.98528 2.01472 9 4.5 9ZM4.5 7C5.88071 7 7 5.88071 7 4.5 7 3.11929 5.88071 2 4.5 2 3.11929 2 2 3.11929 2 4.5 2 5.88071 3.11929 7 4.5 7ZM15.5 9C17.9853 9 20 6.98528 20 4.5 20 2.01472 17.9853 0 15.5 0 13.0147 0 11 2.01472 11 4.5 11 6.98528 13.0147 9 15.5 9ZM15.5 7C16.8807 7 18 5.88071 18 4.5 18 3.11929 16.8807 2 15.5 2 14.1193 2 13 3.11929 13 4.5 13 5.88071 14.1193 7 15.5 7ZM9 15.5C9 17.9853 6.98528 20 4.5 20 2.01472 20 0 17.9853 0 15.5 0 13.0147 2.01472 11 4.5 11 6.98528 11 9 13.0147 9 15.5ZM7 15.5C7 16.8807 5.88071 18 4.5 18 3.11929 18 2 16.8807 2 15.5 2 14.1193 3.11929 13 4.5 13 5.88071 13 7 14.1193 7 15.5Z" class="svg-bg"/>
  <path d="M17.0983 13.5776L18.5158 12.1601C17.7178 11.4391 16.6602 11 15.5 11C13.0147 11 11 13.0147 11 15.5C11 16.6602 11.4391 17.7178 12.1601 18.5158L13.5776 17.0983C13.2169 16.665 13 16.1078 13 15.5C13 14.1193 14.1193 13 15.5 13C16.1078 13 16.665 13.2169 17.0983 13.5776Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAnalyzeCustomMaps4 is a generated icon component.
 */
let IconMedAnalyzeCustomMaps4 = IconMedAnalyzeCustomMaps4_1 = class IconMedAnalyzeCustomMaps4 extends IconBaseElement {
    render() {
        return html `${IconMedAnalyzeCustomMaps4_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAnalyzeCustomMaps4.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAnalyzeCustomMaps4 = IconMedAnalyzeCustomMaps4_1 = __decorate([
    customElement('zui-icon-med-analyze-custom-maps-4')
], IconMedAnalyzeCustomMaps4);
export { IconMedAnalyzeCustomMaps4 };
